export const documentAlertId = 'contract-document-alert';
export const documentDeletedAlertId = 'contract-document-deleted-alert';
export const documentTypeAlertId = 'contract-document-type-alert';
